// App.js
import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation
} from 'react-router-dom';

import Home from './components/Home';
import EmailVerification from './components/Register';
import VerifyAccount from './components/Verify';
import BasicInfoForm from './components/BasicInfoForm';
import SurveyForm from './components/SurveyForm';
import Profile from './components/Profile';
import Login from './components/Login';
import NavBar from './components/NavBar';
import ScrollToTopButton from './components/ScrollToTopButton';
import Start from './components/Start';
import Res from './components/Res';
import ROI from './components/ROI';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import BusinessNameInput from './components/BusinessName';

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      fetch('https://api.nagae.biz/api/users/me', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error('failed');
          }
          return res.json();
        })
        .then((data) => {
          setUser(data);
        })
        .catch((error) => {
          console.error(error);
          localStorage.removeItem('access_token');
        });
    }
  }, []);

  return (
    <Router>
      <NavBarWrapper user={user} setUser={setUser} />
      
      <Routes>
        <Route path="/" element={<Start />} />
        <Route path="/ROI" element={<ROI />} />
        <Route path="/result"  element={<Res email={user?.email} name={user?.name} />} />
        <Route path="/start" element={<Home />} />
        <Route path="/business" element={<BusinessNameInput />} />
        <Route path="/register" element={<EmailVerification />} />
        <Route path="/verify" element={<VerifyAccount setUser={setUser} />} />
        <Route path="/login" element={<Login setUser={setUser} />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/info" element={<BasicInfoForm />} />
        <Route path="/survey" element={<SurveyForm />} />
        <Route path="/profile" element={<Profile setUser={setUser} />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <ScrollToTopButton />
    </Router>
  );
}

// 这个包装组件用来决定是否显示 NavBar
function NavBarWrapper({ user, setUser }) {
  // 通过 useLocation() 获取当前路径
  const location = useLocation();

  // 如果没有 user，或者当前路径是 "/info"，都不显示 NavBar
  if (!user || location.pathname === '/info' || location.pathname === '/') {
    return null;
  }

  // 其他情况，正常显示 NavBar
  return <NavBar user={user} setUser={setUser} />;
}

export default App;
